const offerings = new Map([
  ["360DataHealthCheck", {
    title: "360 Data Health Check",
    description: "Bad data quietly erodes trust in your reports. We audit your pipelines and business logic, fix the inconsistencies we find, and leave you with recommendations to keep your data healthy.",
    icon: "check_circle_outline",
    outcomes: [
      "Reliable numbers in your dashboards",
      "Documented data quality rules",
      "Action plan to prevent future drift"
    ]
  }],
  ["reportAutomation", {
    title: "Report Automation",
    description: "Manual Excel reports cost your analysts hours each week and introduce errors that slow down decisions. We automate the repetitive work so your team can focus on insights instead of copy-paste.",
    icon: "settings_suggest",
    outcomes: [
      "Reports delivered automatically on schedule",
      "Fewer manual errors in stakeholder-facing numbers",
      "Hours of analyst time given back to real analysis"
    ]
  }],
  ["dataAugmentation", {
    title: "Data Augmentation",
    description: "There's an abundance of public and third-party data that can supercharge your own. We help you enrich existing datasets, fill gaps, and build a fuller picture so your team can make sharper decisions.",
    icon: "auto_awesome",
    outcomes: [
      "Richer datasets with fewer blind spots",
      "Integrated third-party sources",
      "Stronger inputs for your models and reports"
    ]
  }],
  ["dataStrategy", {
    title: "Strategy",
    description: "Just starting your data journey, or rethinking the big picture? We help you answer the foundational questions, so you invest in the right tools and architecture for where your business is actually headed.",
    icon: "trending_up",
    outcomes: [
      "Clarity on the KPIs that matter for your team",
      "A right-sized roadmap (no over-engineering)",
      "Confident tool and platform choices"
    ]
  }],
  ["dataIngestion", {
    title: "Data Ingestion",
    description: "We design and implement ETL and ELT pipelines that connect your sources and deliver clean, structured data where your team needs it. The result is less manual wrangling and more trustworthy analytics.",
    icon: "import_export",
    outcomes: [
      "Reliable pipelines from source to warehouse",
      "Clean, well-modeled data on arrival",
      "Less manual intervention day-to-day"
    ]
  }],
  ["dataModelingAndWarehousing", {
    title: "Data Modeling & Warehousing",
    description: "We build scalable data models and warehouses tailored to how your team actually reports and analyzes. The focus is on performance, clarity, and a structure that grows with your business.",
    icon: "storage",
    outcomes: [
      "Models your analysts find intuitive",
      "Fast queries even as data grows",
      "Clean foundation for BI and ML"
    ]
  }],
  ["realTimeDataProcessing", {
    title: "Real-Time Data Processing",
    description: "When decisions can't wait for tomorrow's report, real-time data delivery makes the difference. We help you pick the right cadence (batch, micro-batch, or streaming) and stand up a solution that delivers on time.",
    icon: "play_arrow",
    outcomes: [
      "Fresh data in dashboards within minutes (or seconds)",
      "The right trade-off between cost and latency",
      "Resilient delivery with monitoring built in"
    ]
  }],
  ["customEngineeringSolutions", {
    title: "Custom Engineering Solutions",
    description: "Some problems don't fit a cookie-cutter tool. We collaborate with your team to scope, design, and build bespoke integrations, micro-applications, and reports that match how you actually work.",
    icon: "build",
    outcomes: [
      "Solutions tailored to your workflows",
      "Tight collaboration through specs and review",
      "Documented handover your team can maintain"
    ]
  }],
  ["cloudDataMigrations", {
    title: "Cloud Data Migrations",
    description: "Moving your database to the cloud should reduce risk, not add it. We plan and execute migrations carefully so your data lands safely, with minimal disruption to the business.",
    icon: "cloud_upload",
    outcomes: [
      "Smooth cutover with a tested rollback plan",
      "Validated data integrity post-migration",
      "Cloud-native architecture from day one"
    ]
  }],
  ["cloudDataWarehousing", {
    title: "Cloud Data Warehousing",
    description: "Whether it's Snowflake, BigQuery, Redshift, or Databricks, we set up and tune cloud warehouses that match your analytical needs. The goal is fast access to the data your team needs, without surprises on the bill.",
    icon: "warehouse",
    outcomes: [
      "Right-sized warehouse for your workload",
      "Performance tuned for your real queries",
      "Predictable monthly spend"
    ]
  }],
  ["cloudCostOptimization", {
    title: "Cloud Cost Optimization",
    description: "Your cloud spend should scale with value, not surprise you each month. We find the inefficiencies, recommend changes you can live with, and set up budgets and alerts so cost stays under control.",
    icon: "credit_card",
    outcomes: [
      "Lower monthly cloud bills",
      "Budgets and alerts so there are no surprises",
      "A clear plan for ongoing optimization"
    ]
  }]
]);

export default offerings;
